export default __webpack_public_path__ + "static/media/a0ee5fba-ca7c-4a2b-be96-e795512d338a.3325735d.jpg";